<template>
  <div id="appRoot">
    <div class="overlay">
      <div v-if="modal" class="modal">
        <h3>{{modal.header}}</h3>
        <span class="text-mute">{{modal.message}}</span>
        <a class="button" @click="modalOK(); hideModal(); return false;">{{modal.okBtn}}</a>
        <a class="button empty" @click="hideModal(); return false;" v-if="!modal.hideCloseBtn">{{modal.closeBtn}}</a>
      </div>
    </div>
    <header>
      <div class="content">
        <div class="hamburger-menu" @click="menuToggle">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
        <div class="logo-box">
          <a href class="logo"></a>
        </div>
        <div class="menu-items">
          <div :class="['menu-item', !scrolledAnchor ? 'active' : '']">
            <a @click="scrollTo('dash')">Vaše vzdelávanie</a>
          </div>
          <div :class="['menu-item', scrolledAnchor == 'trainers' ? 'active' : '']">
            <a @click="scrollTo('trainers')">Naši lektori</a>
          </div>
          <div :class="['menu-item', scrolledAnchor == 'portfolio' ? 'active' : '']">
            <a @click="scrollTo('portfolio')">Portfólio</a>
          </div>
          <div :class="['menu-item', scrolledAnchor == 'news' ? 'active' : '']">
            <a @click="scrollTo('news')">Novinky</a>
          </div>
          <div :class="['menu-item', scrolledAnchor == 'contact' ? 'active' : '']">
            <a @click="scrollTo('contact')">Kontakt</a>
          </div>
        </div>
        <div class="right-content text-mute">
          <div class="language-select">
            <div class="language-active">SK</div>
            <div class="language-dropdown">
              <div class="language-dropdown-item active">SK</div>
              <div class="language-dropdown-item">EN</div>
            </div>
          </div>
          <div class="name">
            <router-link
              :to="{name: 'profile'}"
            >{{$api.login.data.user.name}} {{$api.login.data.user.lastname}}</router-link>
          </div>
          <div class="logout">
            <router-link class="logout-icon" :to="{name: 'logout'}"></router-link>
          </div>
        </div>
      </div>
      <div class="view-profile">
        <div class="content">
          <div class="name">{{$api.login.data.user.name}} {{$api.login.data.user.lastname}}</div>
          <a href>Pozrieť profil ></a>
        </div>
      </div>
    </header>
    <main>
      <Toaster></Toaster>
      <div class="content">
        <div class="profile">
          <div class="profile-image">
            <div class="img">
              <img src="/static/customer/images/head.png" alt="Profile Image" />
            </div>
          </div>
          <div class="profile-top-content">
            <div class="name">{{$api.login.data.user.name}} {{$api.login.data.user.lastname}}</div>
            <div class="text text-mute">{{$api.login.data.user.company}}</div>
            <div class="split">
              <div></div>
            </div>
            <router-view name="sidemenu"></router-view>
            <div class="bottom-text">Vaše kurzy</div>
          </div>
          <div class="profile-bottom-content">
            <div v-for="course in $api.login.data.courses">
              <div class="box">
                <span>{{course.course.lang.name}}</span>
                <div class="progress-bar">
                  <div class="fill" :style="{width: course.course.progress + '%'}"></div>
                </div>

                <router-link
                  v-if="course.course.active && !course.course.finished"
                  :to="{name: course.course.type, params:{id: course.course.id}}"
                >Pokračovať &gt;</router-link>

                <router-link
                  v-if="course.course.finished"
                  :to="{name: course.course.type, params:{id: course.course.id}}"
                >Zobraziť výsledky &gt;</router-link>

                <a v-if="!course.course.active && !course.course.finished">Neaktívny</a>
              </div>
            </div>
            <div class="profile-view-more">
              <div class="view-more"></div>
            </div>
          </div>
        </div>
        <router-view></router-view>
      </div>

      <dashboard-content></dashboard-content>
    </main>
    <footer>
      <div class="content">
        <div class="contact">
          <div class="top">
            <h1>Kontakt</h1>
          </div>
          <div class="bottom">
            <div class="text text-mute">
              Maxman Consultants
              <br />
              <a href="mailto:info@maxman.online">info@maxman.online</a>
            </div>
            <div class="icons">
              <a href="https://www.facebook.com/search/top/?q=maxman%20consultants&epa=SEARCH_BOX" target="blank" class="icon fb"></a>
              <a href="https://www.linkedin.com/company/maxman-consultants/" target="blank" class="icon linkedin"></a>
              <a href="https://www.instagram.com/maxman_consultants/?hl=sk" target="blank" class="icon insta"></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<style lang="less" >
.range-slider-fill {
  background-color: red !important;
}
header .menu-item {
  cursor: pointer;
}
.hide_mobile_flex {
  display: none !important;
}
.show_mobile_flex {
  display: flex !important;
}

main .content .main-content-box.result .right .finished.show_mobile_flex {
  padding: 20px 0;
  justify-content: center;
  color: #b11116;
}
@media screen and (max-width: 575.98px) {
  main .content .main-content .main-content-box {
    flex-direction: column !important;
    .left, .right{
      width: 100% !important;
    }
  }
}
@media screen and (max-width: 575.98px) {
  main .content .main-content.socstyle .main-content-box.q {
    flex-direction: row !important;
    .left{
      width: 50% !important;
    }
    .right{
      margin-top: 0!important;
      width: 50% !important;
    }
  }
}
@media only screen and (min-width: 800px) {
  .hide_mobile_flex {
    display: flex !important;
  }

  .show_mobile_flex {
    display: none !important;
  }
}
</style>
<script>
import "vue-range-slider/dist/vue-range-slider.css";
import "vue-range-slider/dist/vue-range-slider.css";
import Toaster from "./elements/Toaster";
import "./style/theme.less";
import MmSelect from "./elements/custom/MmSelect";
import MmSidebar from "./elements/custom/MmSidebar";
import DashboardContent from "./pages/dashboard/DashBoardContent";

export default {
  components: {
    Toaster,
    MmSelect,
    MmSidebar,
    DashboardContent
  },
  data: () => ({
    lang: 0,
    modal: null
  }),

  computed: {
    route() {
      return this.$route.name;
    },
    anchor() {
      return this.$api.shared.anchor;
    },
    scrolledAnchor() {
      return this.$api.shared.scrolledAnchor;
    }
  },


  created() {
    this.$api.bus.on("course-status-change", (id, progress) => {
      for (var i in this.$api.login.data.courses) {
        if (this.$api.login.data.courses[i].course.id == id) {
          this.$api.login.data.courses[i].course.progress = progress;
        }
      }
    });


    this.$api.bus.on("app-change", () => {
      this.onChange();
    });

    this.$api.bus.trigger("app-change");

    this.$api.translator.waitInit().then(() => {
      this.lang = this.$api.translator.getCurrent();
    });

    this.$api.bus.on("open-modal", e => {
      this.openModal(e);
    });
  },
  watch: {
    $route: {
      handler() {
        this.$api.bus.trigger("app-change");
      },
      immediate: true
    },
    lang(v) {
      this.$api.translator.setCurrent(v);
    },
    "$api.shared.anchor": {
      handler(v) {
        if (v) {
          if (this.$route.name !== "Dashboard") {
            this.$router.push({ name: "Dashboard" });
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    scrollTo(v) {
      if (!v) {
        this.$router.push({ name: "Dashboard" });
      }
      this.$api.shared.anchor = "nope";
      this.$nextTick(() => {
        this.$api.shared.anchor = v;
      });
    },
    onChange() {},
    menuToggle() {
      window.document
        .querySelector(".hamburger-menu")
        .classList.toggle("change");
      window.document.querySelector("header").classList.toggle("open");
    },
    openModal(m) {
      this.modal = m;
      window.document.querySelector(".overlay").classList.add("open");
    },
    hideModal() {
      window.document.querySelector(".overlay").classList.remove("open");
    },
    modalOK() {
      this.modal.cb();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/public_app/App.vue